/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsEvidenceExportGipReportMutationRequest, AuditReportsEvidenceExportGipReportMutationResponse, AuditReportsEvidenceExportGipReportPathParams, AuditReportsEvidenceExportGipReport400, AuditReportsEvidenceExportGipReport401, AuditReportsEvidenceExportGipReport403, AuditReportsEvidenceExportGipReport404 } from "../models/AuditReportsEvidenceExportGipReport";

export function getAuditReportsEvidenceExportGipReportUrl(id: AuditReportsEvidenceExportGipReportPathParams["id"]) {
  const res = { method: 'POST', url: `/audit-reports/v1/reports/gip/report/${id}/evidence-export` as const }
  return res
}

/**
 * @summary Start evidence export
 * {@link /audit-reports/v1/reports/gip/report/:id/evidence-export}
 */
export async function auditReportsEvidenceExportGipReport(id: AuditReportsEvidenceExportGipReportPathParams["id"], data: AuditReportsEvidenceExportGipReportMutationRequest, config: Partial<RequestConfig<AuditReportsEvidenceExportGipReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsEvidenceExportGipReportMutationResponse, ResponseErrorConfig<AuditReportsEvidenceExportGipReport400 | AuditReportsEvidenceExportGipReport401 | AuditReportsEvidenceExportGipReport403 | AuditReportsEvidenceExportGipReport404>, AuditReportsEvidenceExportGipReportMutationRequest>({ method : "POST", url : getAuditReportsEvidenceExportGipReportUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}